const getWarningExplanation = (packageName) => {
  return `Your app or its dependencies are using ${packageName}. ${packageName} depends on being provided with an implementation to work, but no implementation has been provided. In your app use registerImplementation from ${packageName} to register an implementation.`;
};
const createStubImplementation = (packageName, defaultImplementation) => {
  const _implementation = {};
  const registerImplementation = (implementation2) => {
    Object.assign(_implementation, implementation2);
  };
  const defaultImplementationEntries = Object.entries(defaultImplementation);
  const implementationWithWarningAndFallbackEntries = defaultImplementationEntries.map(
    ([methodName, defaultMethod]) => {
      return [
        methodName,
        (...args) => {
          const method = _implementation[methodName];
          if (!method) {
            const error = new Error(
              `${methodName} called without an implementation!

${getWarningExplanation(
                packageName
              )}`
            );
            setTimeout(() => {
              throw error;
            });
            return defaultMethod(...args);
          }
          return method(...args);
        }
      ];
    }
  );
  const implementation = Object.fromEntries(
    implementationWithWarningAndFallbackEntries
  );
  setTimeout(() => {
    if (Object.keys(defaultImplementation).every(
      (methodName) => _implementation[methodName]
    )) {
      return;
    }
    throw new Error(
      `Missing implementation for ${packageName}!

${getWarningExplanation(
        packageName
      )}`
    );
  });
  return { ...implementation, registerImplementation };
};
const affirmSingleton = (packageName) => {
  if (typeof window !== "undefined") {
    const sentinel = `__ARDOQ_MODULE_IN_USE__${packageName.replace("@", "").replace("/", "__").replace("-", "_").toUpperCase()}`;
    if (window[sentinel]) {
      throw new Error(`${packageName} should be imported only once`);
    }
    window[sentinel] = true;
  }
};
export {
  affirmSingleton,
  createStubImplementation
};
//# sourceMappingURL=index.js.map
